import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";

import NotFound from "core/NotFound";
import LoadingSpinner from "core/LoadingSpinner";

import { IS_USER_A_CREATOR } from "./queries";

const CreatorProfilePage = () => {
    const { content, username } = useParams();
    const { data, loading } = useQuery(IS_USER_A_CREATOR, {
        variables: { username }
    });

    if (loading) return <LoadingSpinner />;

    const { creatorData } = data;

    if (!creatorData || content !== "photos") return <NotFound />;

    return (
        <>
            <h1>Creator Profile Page</h1>
            <p>
                {content} by {username}
            </p>
        </>
    );
};

export default CreatorProfilePage;
